import { render, staticRenderFns } from "./cj-upload.vue?vue&type=template&id=6fea1478&scoped=true"
import script from "./cj-upload.vue?vue&type=script&lang=js"
export * from "./cj-upload.vue?vue&type=script&lang=js"
import style0 from "./cj-upload.vue?vue&type=style&index=0&id=6fea1478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea1478",
  null
  
)

export default component.exports